{
  "version": 1,
  "asset_id": "3701443f-a592-4d9a-a09f-a98c7933a1cd",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/3701443f-a592-4d9a-a09f-a98c7933a1cd/clip-img_2357.mp4",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/3701443f-a592-4d9a-a09f-a98c7933a1cd/clip-img_2357.mp4",
  "original_filename": "clip-img_2357.mp4",
  "size": 397703,
  "content_type": "video/mp4",
  "created_at": "2026-08-01T22:33:11Z"
}
